import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatRealmUpdatedEvent} from '../types/events'
import {NinchatState} from 'api/types'
import {extractProperties} from '.'

export const realmUpdated: CaseReducer<NinchatState> = (state, action) => {
    const {
        realm_id,
        realm_settings,
    } = extractProperties<NinchatRealmUpdatedEvent>(action.payload)

    state.user_realms[realm_id].realm_settings = {
        ...state.user_realms[realm_id].realm_settings,
        ...realm_settings,
    }
}
